import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const ArrowUpIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6666 7.69954L16.9541 11.987C17.2924 12.3253 17.8408 12.3253 18.1791 11.987C18.5174 11.6488 18.5174 11.1003 18.1791 10.762L12.4987 5.08165C12.1082 4.69113 11.475 4.69113 11.0845 5.08165L5.4041 10.762C5.06583 11.1003 5.06583 11.6488 5.4041 11.987C5.74238 12.3253 6.29083 12.3253 6.6291 11.987L10.9166 7.69954V17.4995C10.9166 17.9828 11.3084 18.3745 11.7916 18.3745C12.2749 18.3745 12.6666 17.9828 12.6666 17.4995V7.69954Z"
      />
    </Icon>
  );
};
